import script from "./Platformer.vue?vue&type=script&lang=js"
export * from "./Platformer.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__